import { BookingController, PaymentLinkController } from '../../controllers';
import { useNavigate, useParams } from 'react-router-dom';
import { object, string, number } from 'yup';
import { BookingLinkDetails } from '../../pages';
import { bookingStore, paymentLinkStore } from '../../stores';
import React, { useEffect, useState } from 'react';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import * as yup from 'yup';

const BookingLinkDetailsContainer = () => {
	const [loading, setLoading] = useState(true);
	const [showCharge, setshowCharge] = useState(false);
	const [paystackCharge, setPaystackCharge] = useState(0);

	const { id } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		const getBookingLinkDetails = async () => {
			setLoading(true);

			await Promise.all([
				BookingController.getBookingLinkDetails(id),
				BookingController.bookingLinkUnavailableDates(id),
			]);

			setLoading(false);
		};
		getBookingLinkDetails();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const bookingLinkDetails = bookingStore.bookingLinkDetails;
	const charges = paymentLinkStore.charges;

	const getExactCharge = async values => {
		let payload;

		payload = {
			amount: values.amount,
			quantity: 1,
			chargeSplit: bookingLinkDetails.chargeSplit,
		};

		const getPaystackCharge =
			(1.5 / 100) * (payload.amount * payload.quantity) + 100;

		if (payload.chargeSplit === 'MY BUSINESS') {
			setPaystackCharge(0);
		} else if (
			payload.chargeSplit === 'EQUAL SPLIT' &&
			getPaystackCharge > 2000
		) {
			setPaystackCharge(1000);
		} else if (payload.chargeSplit === 'EQUAL SPLIT') {
			setPaystackCharge(getPaystackCharge / 2);
		} else if (getPaystackCharge > 2000) {
			setPaystackCharge(2000);
		} else {
			setPaystackCharge(getPaystackCharge);
		}

		if (bookingLinkDetails.currencyCode === 'NGN') {
			payload.name = 'NGN PAYMENT COLLECTION CHARGE';
		}

		if (bookingLinkDetails.currencyCode === 'USD') {
			payload.name = 'USD PAYMENT COLLECTION CHARGE';
		}

		if (bookingLinkDetails.currencyCode === 'GBP') {
			payload.name = 'GBP PAYMENT COLLECTION CHARGE';

			if (bookingLinkDetails.currencyCode === 'NGN') {
				payload.name = 'NGN PAYMENT COLLECTION CHARGE';
			}
		}

		if (bookingLinkDetails.currencyCode === 'EUR') {
			payload.name = 'EUR PAYMENT COLLECTION CHARGE';
		}

		const { status } = await PaymentLinkController.getCharges(payload);

		if (status === constant.Success) {
			setshowCharge(true);
		} else {
			setshowCharge(false);
		}
	};

	const validationSchema = () => {
		return object({
			amount: number()
				.when('acceptPartPayment', {
					is: true,
					then: number().min(yup.ref('minDeposit'), ({ min }) => {
						return `Amount cannot be less than ${min}`;
					}),
					otherwise: number().when('totalAmount', {
						is: totalAmount => totalAmount > 0,
						then: number().min(yup.ref('totalAmount'), ({ min }) => {
							return `Amount cannot be less than ${min}`;
						}),
					}),
				})
				.required('Amount is required'),
			fullname: string()
				.required('Enter your Full name')
				.test('fullname', 'First and Last name is required', function (value) {
					const names = value ? value.split(' ') : [];
					return names.length > 1 && names[0].length > 1 && names[1].length > 1;
				}),
			email: string()
				.trim()
				.email('Enter a valid Email')
				.required('Email Address is required'),
			// quantity: yup.number().when('acceptQuantity', {
			// 	is: true,
			// 	then: schema =>
			// 		schema.min(1, 'Minimum should be 1').required('Quantity is required'),
			// 	otherwise: schema => schema.optional(),
			// }),
			mobile: yup.string().when('acceptPhoneNumber', {
				is: true,
				then: schema => schema.required('phone number is required'),
				otherwise: schema => schema.optional(),
			}),
			sessionDateTime: yup.date().required('Enter Payment booking date'),
			country: string().required('Select a Country'),
			state: string().required('Select a State'),
		});
	};

	const onSubmit = async values => {
		setLoading(true);

		delete values.acceptPhoneNumber;
		delete values.acceptPartPayment;
		delete values.minDeposit;

		const payWith = values.payWith;

		let payload = {};
		payload = {
			...values,
		};

		if (payload.mobile === '') {
			delete payload.mobile;
		}

		if (payload.note === '') {
			delete payload.note;
		}

		delete payload.payWith;

		const { status, errorMessage, data } =
			await BookingController.createBookingLinkInvoice(payload);

		if (status === constant.Success) {
			MimaToastUtil.success({
				message: 'Navigating to Payment Page',
			});
			const invoice = data;

			if (invoice.currencyCode === 'NGN' && payWith === 'TRANSFER') {
				navigate(`/mima-checkout?invoiceId=${invoice._id}`);
			} else if (invoice.currencyCode === 'NGN' && payWith === 'CARD') {
				window.open(invoice.paymentUrl, '_self');
			} else {
				window.open(invoice.paymentUrl, '_self');
			}
			setshowCharge(false);
			setLoading(false);
		} else {
			setLoading(false);
			MimaToastUtil.error({ message: errorMessage });
		}
	};

	return (
		<BookingLinkDetails
			bookingLinkDetails={bookingLinkDetails}
			loading={loading}
			validationSchema={validationSchema}
			onSubmit={onSubmit}
			paystackCharge={paystackCharge}
			getExactCharge={getExactCharge}
			charges={charges}
			showCharge={showCharge}
			setshowCharge={setshowCharge}
			unavailableDates={bookingStore.bookingLinkUnavailableDates}
		/>
	);
};

export default BookingLinkDetailsContainer;
